Vue.component('the-cart', {
    props: {
        isFull: false,
    },
    data() {
        return {
            opened: false,
            animated: false,
        }
    },
    computed: {
        items(){
            return store.state.order.items;
        },
        itemsCount() {
            let count = 0;
            for (let item of store.state.order.items) {
                count += item.count;
            }
            return count;
        },
        totalPrice(){
            let price = 0;
            for (let item of this.items) {
                price += item.product.price * item.count;
            }
            return price;
        },
        cartEmpty() {
            return this.items.length == 0;
        }
    },
    watch: {
        itemsCount() {
            this.animated = true
            setTimeout(() => {
                this.animated = false
            }, 500)
        }
    },
    methods: {
        toggle() {
            this.opened = !this.opened
        },
        close() {
            this.opened = false
        },
        open() {
            this.opened = true
        },
        clickOutside(e) {
            if (!this.$refs.cartContainer.contains(e.target)) {
                this.close();
            }
        },
        productTotalPrice(item) {
            return item.product.price * item.count;
        },
        formatPrice(price) {
            return price.toLocaleString('ru');
        },
        getName(product) {
            return ProductHelper.getTitle(product);
        },
        deleteItem(item, event) {
            if (event) {
                event.stopPropagation();
            }
            store.dispatch('updateItemInCart', {product_id: item.product.id, updateDirection: 0});
        },
        changeItemsCount(item) {
            item.count = ProductHelper.changeCount(item.product, item.count);
            store.dispatch('setItemInCart', {
                product_id: item.product.id,
                count: item.count
            });
        },
        reduceItems(item) {
            item.count--;
            item.count = ProductHelper.changeCount(item.product, item.count, true);
            store.dispatch('setItemInCart', {
                product_id: item.product.id,
                count: item.count
            });
        },
        addItems(item) {
            item.count++;
          console.log(item.product)
            item.count = ProductHelper.changeCount(item.product, item.count);
            store.dispatch('setItemInCart', {
                product_id: item.product.id,
                count: item.count
            });
        },
    },
    created() {
        if (!this.isFull) {
            document.addEventListener('click', this.clickOutside);
        }
    },

});
